import { render } from "./AddonServices.vue?vue&type=template&id=0f1336d8&scoped=true"
import script from "./AddonServices.vue?vue&type=script&lang=js"
export * from "./AddonServices.vue?vue&type=script&lang=js"

import "./AddonServices.vue?vue&type=style&index=0&id=0f1336d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1336d8"]])

export default __exports__